/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Printer: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M5 4.5C3.34315 4.5 2 5.84315 2 7.5V17C2 17.5523 2.44772 18 3 18H5.5V21C5.5 21.5523 5.94772 22 6.5 22H17.5C18.0523 22 18.5 21.5523 18.5 21V18H21C21.5523 18 22 17.5523 22 17V7.5C22 5.84315 20.6569 4.5 19 4.5H5ZM16.5 13V20H7.5V13H16.5ZM19 6.5C19.5523 6.5 20 6.94772 20 7.5V16H18.5V12C18.5 11.4823 18.1067 11.0562 17.6025 11.0049L17.5 11H6.5C5.98232 11 5.55622 11.3933 5.50488 11.8975L5.5 12V16H4V7.5C4 6.94772 4.44772 6.5 5 6.5H19ZM16 8C15.4477 8 15 8.44772 15 9C15 9.55228 15.4477 10 16 10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H16Z'
      fill='currentColor'
    />
  </React.Fragment>
)
